// Mock data for Savanna Skies Ltd - Aircraft Leasing & Financing

export const companyInfo = {
  name: "Savanna Skies Ltd",
  tagline: "Elevating African Aviation",
  description: "An African-owned and operated aircraft leasing and financing company",
  founded: "2025",
  email: "sales@savannaskies.co.za",
  phone: "+27 83 467 0112 and +44 7934 517 246",
  address: "South Africa, Kenya, Nigeria and United Kingdom"
};

export const heroContent = {
  headline: "Powering Africa's Aviation Future",
  subheadline: "African-owned aircraft leasing and financing solutions for a growing continent",
  description: "Savanna Skies delivers flexible operating leases, engine financing, and strategic portfolio solutions to airlines across Africa and beyond.",
  ctaText: "Explore Our Fleet",
  ctaSecondary: "Contact Us"
};

export const services = [
  {
    id: 1,
    title: "Operating Leases",
    description: "Comprehensive aircraft operating lease solutions for narrow-body and wide-body aircraft. Flexible terms tailored to your operational needs with modern, fuel-efficient fleet options.",
    icon: "Plane"
  },
  {
    id: 2,
    title: "Engine Leasing & Management",
    description: "Strategic engine leasing programs and asset management services. Access to modern powerplants including LEAP, CFM56, and Trent engine families with dedicated technical support.",
    icon: "Settings"
  },
  {
    id: 3,
    title: "Portfolio Management",
    description: "End-to-end aviation asset management including acquisition, leasing, maintenance oversight, and strategic remarketing to maximize asset value and utilization.",
    icon: "BarChart3"
  },
  {
    id: 4,
    title: "Financing Solutions",
    description: "Customized aircraft financing structures including sale-leaseback transactions, secured lending, and debt instruments designed for airline operational flexibility.",
    icon: "DollarSign"
  }
];

export const fleetData = {
  totalAircraft: 52,
  averageAge: "7.2 years",
  customers: "15+ airlines",
  continents: "3 continents",
  fleetTypes: [
    {
      type: "Boeing",
      count: 18,
      description: "737, 737NG, 737 Max, 787, 777, and 747"
    },
    {
      type: "Airbus",
      count: 20,
      description: "A318, A319, A320, A330 and A340"
    },
    {
      type: "Embraer",
      count: 8,
      description: "E-Jet Family (E175, E190, E195-E2)"
    },
    {
      type: "De Havilland",
      count: 6,
      description: "Dash 8-400 regional turboprops"
    }
  ]
};

export const aboutContent = {
  mission: "To drive African aviation growth by providing accessible, flexible aircraft leasing and financing solutions that empower airlines to expand routes, enhance connectivity, and serve communities across the continent.",
  vision: "To become Africa's leading aircraft lessor, recognized for innovative financing structures, customer-centric service, and a commitment to sustainable aviation growth.",
  values: [
    {
      title: "African Leadership",
      description: "Proudly African-owned and operated, understanding the unique needs and opportunities of the continent's aviation market."
    },
    {
      title: "Financial Innovation",
      description: "Creative, flexible financing solutions tailored to the operational and economic realities of emerging markets."
    },
    {
      title: "Partnership Focus",
      description: "Building long-term relationships with airlines, manufacturers, and financial institutions to deliver mutual success."
    },
    {
      title: "Sustainability",
      description: "Committed to modern, fuel-efficient aircraft that reduce environmental impact and operating costs."
    }
  ]
};

export const stats = [
  { label: "Aircraft & Engines", value: "69+" },
  { label: "Average Fleet Age", value: "6.8 yrs" },
  { label: "Airline Partners", value: "12+" },
  { label: "Countries Served", value: "18" }
];

export const whyChooseUs = [
  {
    title: "Regional Expertise",
    description: "Deep understanding of African aviation markets, regulatory environments, and operational challenges."
  },
  {
    title: "Modern Fleet",
    description: "Young, fuel-efficient aircraft portfolio featuring the latest A320neo and 737 MAX technology."
  },
  {
    title: "Flexible Terms",
    description: "Customized lease structures and financing options designed for operational flexibility and growth."
  },
  {
    title: "Responsive Service",
    description: "Dedicated relationship management and technical support teams committed to your success."
  }
];

export const contactReasons = [
  "Explore leasing opportunities",
  "Discuss financing solutions",
  "Request fleet information",
  "Partnership inquiries",
  "Investor relations"
];